import React from 'react';

function Footer() {
  return (
    <footer>
      <div className="disclaimer">
        Paid for by DCCC &middot; 430 S. Capitol Street, S.E. Washington, D.C. 20003 &middot;
        202-863-1500
        <br /> Not authorized by any candidate or candidate&apos;s committee.
      </div>
    </footer>
  );
}

export default Footer;
